import type { HandleInputChange } from "./types";

type TextareaInputProps = {
    name: string;
    value?: string;
    placeholder?: string;
    rows?: number;
    cols?: number;
    onChange: HandleInputChange;
};

const TextareaInput = ({ name, value = "", placeholder, rows, cols, onChange }: TextareaInputProps) => {
    return (
        <textarea
            className="form-control"
            placeholder={placeholder}
            rows={rows}
            cols={cols}
            name={name}
            value={value}
            onChange={(event) => onChange(event, name, event.target.value)}
        />
    );
};

export default TextareaInput;
